import { FieldTitle } from '../common/index';
import React from 'react';
import PhoneInput, { formatPhoneNumberIntl, isValidPhoneNumber } from 'react-phone-number-input';
import de from 'react-phone-number-input/locale/de';
import flags from 'react-phone-number-input/flags'

class TelInput extends React.PureComponent {
  constructor() {
    super();
    this.state = {
      value: ''
    };
  }

  render() {
    const { value } = this.state;
    const { label, internalTitle, formId, required, placeholder, options, className } = this.props;
    const contentArticleFormId = `content_article_form-${this.props.contentArticleFormId}`;
    const forId = `${contentArticleFormId}-${FieldTitle.titleFor(internalTitle, formId)}`;
    const asterisk = required ? ' *' : null;
    const usedLabel = label.length ? (
      <label htmlFor={forId}>
        {label}
        {asterisk}
      </label>
    ) : null;
    let pattern;

    if (!isValidPhoneNumber(value)) {
      // set a pattern that does not match a valid number to trigger HTML5 validation for the field
      pattern = '^[A-Z]';
    }

    return (
      <div className={`${className} input tel`}>
        {usedLabel}
        <PhoneInput
          id={forId}
          required={required}
          maxLength={options.maxlength}
          placeholder={required && !label.length ? `${placeholder} *` : placeholder}
          value={value}
          onChange={(newValue) => this.setState({ value: newValue })}
          labels={de}
          country="DE"
          pattern={pattern}
          flags={flags}
        />
        <input
          type="hidden"
          name={internalTitle}
          value={formatPhoneNumberIntl(value).replace(/\s/g, '')}
        />
      </div>
    );
  }
}

TelInput.propTypes = {
  label: React.PropTypes.string,
  internalTitle: React.PropTypes.string,
  placeholder: React.PropTypes.string,
  formId: React.PropTypes.number,
  contentArticleFormId: React.PropTypes.number,
  required: React.PropTypes.bool,
  className: React.PropTypes.string,
  options: React.PropTypes.object
};

TelInput.defaultProps = {
  className: 'formgroup'
};

export default TelInput;



// WEBPACK FOOTER //
// ./components/forms/telInput.js